
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TAnswerBlock } from "@/modules/Questionnaire/components/AnswerBlocks/TAnswerBlocks";
import { SMCases, SMHorizontalQuestionnaire, SMQuestionnaire } from "@/store";

export type BandOption = {
  label: string | unknown | undefined;
  value: string | unknown | undefined;
};

const CASE_TYPE = "case";
const ROLE_TYPE = "role";

@Component
export default class AnswerBlockBandSelect extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;

  input = "";

  @Watch("input")
  updateAnswer(value: string) {
    const { index, answerBlockData, loopIndex } = this;

    if (index == null) return;

    SMQuestionnaire.updateAnswer({
      index,
      value,
      required: answerBlockData.is_required,
      answer_block_id: answerBlockData.ID,
      loop_index: loopIndex,
      condition: answerBlockData.condition,
    });

    window.sessionStorage.setItem(`alias.${answerBlockData.alias}`, this.query);
  }

  getAnswerBlockData() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (!answer) return;

    this.query = answer.value;
  }

  query = "";

  @Watch("query")
  onQueryUpdate(val: string): void {
    if (!val) return;

    this.unsetSelection();

    this.input = val;
  }

  selection = "";

  options: BandOption[] = [];

  unsetSelection() {
    this.selection = "";
  }

  loading = false;

  get taskId() {
    const { taskId } = this.$route.params;

    return taskId ? Number(taskId) : SMHorizontalQuestionnaire.taskId;
  }

  async fetchOptions() {
    const answerQuery = { ...SMQuestionnaire.getAnswerQuery };

    const target_id = (answerQuery as any).target_id || SMCases.caseId;

    const type = Object.keys(answerQuery).length ? ROLE_TYPE : CASE_TYPE;

    const query = {
      target_id,
      type,
      task_id: this.taskId,
    };

    try {
      this.loading = true;

      const { data } = await this.axios.get(API_ROUTES.GET_BAND(query));

      if (!data || !data.band?.length) return;

      const band = [...new Set(data.band)];

      this.options = band.reduce((acc: BandOption[], cur) => {
        if (cur) acc.push({ label: cur, value: cur });

        return acc;
      }, []);
    } finally {
      this.loading = false;
    }
  }

  @Watch("selection")
  onSelectionUpdate(val: string): void {
    if (!val) return;

    this.input = val;
  }

  setAnswer(value: string) {
    if (!value) return;

    const optionValues = this.options.map((option) => option.value);

    if (this.options.length && optionValues.includes(value)) this.selection = value;

    this.input = value;
  }

  async created() {
    this.getAnswerBlockData();

    await this.fetchOptions();

    this.setAnswer(this.query);
  }
}
